import { computed, ref } from 'vue'

import { defineStore } from 'pinia'

import { useMaintenanceStore } from '@/stores/helpers/maintenance.js'

let nextId = 1

export const useNotificationStore = defineStore('notification', () => {
  // State
  const notifications = ref([])

  // Getters
  const getNotificationsByKind = computed(() => kind => {
    return notifications.value ? notifications.value.filter(notification => notification.kind === kind) : false
  })

  // Actions
  const add = notification => {
    if (useMaintenanceStore().isMaintenanceMode) {
      return
    }

    const checkExists = notifications.value.filter(item => item.id === notification.id).length

    if (typeof notification.id !== 'undefined' && checkExists) {
      return
    }

    notifications.value.push({
      ...notification,
      id: notification.id || nextId++
    })
    window.dispatchEvent(new Event('resize'))
  }

  const remove = notificationToRemove => {
    notifications.value = notifications.value.filter(notification => notification.id !== notificationToRemove.id)
  }

  const removeMany = notificationsToRemove => {
    const ids = new Set(notificationsToRemove.map(notification => notification.id))

    notifications.value = notifications.value.filter(notification => !ids.has(notification.id))
  }

  return {
    notifications,
    getNotificationsByKind,
    add,
    remove,
    removeMany
  }
})
